import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import CampaignStatus from './CampaignStatus';
import CampaignsCard from './CampaignsCard';

const CampaignsCards = ({ stats, period, toggleCampaign, campaigns, rescheduleStatuses, isClickTrackingVerified }) => {
  const fetch = useFetch();
  const [facebookStatuses, setFacebookStatuses] = useState();
  const [googleStatuses, setGoogleStatuses] = useState();
  const [loadError, setLoadError] = useState();

  const { accountId, domainId } = useParams();

  const campaignElements = [];

  const fetchStatuses = useCallback(
    async (campaignIds, type) => {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/campaigns/${type}/progressStatus`, {
        method: 'POST',
        body: JSON.stringify({ campaignIds }),
      })
        .then((response) => {
          if (type === 'facebook') {
            setFacebookStatuses(response.statuses);
          }
          if (type === 'google') {
            setGoogleStatuses(response.statuses);
          }
        })
        .catch(setLoadError);
    },
    [accountId, domainId, fetch]
  );

  useEffect(() => {
    const campaignIdsWithFacebookNode = campaigns
      .filter((campaign) => campaign.flow.nodes.some((node) => node.data?.custom?.key === 'sendFacebookAd'))
      .map((campaign) => campaign.id);

    const campaignIdsWithGoogleNode = campaigns
      .filter((campaign) => campaign.flow.nodes.some((node) => node.data?.custom?.key === 'sendGoogleAd'))
      .map((campaign) => campaign.id);
    if (campaignIdsWithFacebookNode.length > 0) {
      fetchStatuses(campaignIdsWithFacebookNode, 'facebook');
    }
    if (campaignIdsWithGoogleNode.length > 0) {
      fetchStatuses(campaignIdsWithGoogleNode, 'google');
    }
  }, [campaigns, fetchStatuses]);

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  for (let i = 0; i < campaigns.length; i++) {
    const campaign = campaigns[i];
    if (campaign.type !== 'simple') {
      continue;
    }
    let status = (
      <CampaignStatus
        i={i}
        campaign={campaign}
        toggleCampaign={toggleCampaign}
        rescheduleStatus={rescheduleStatuses?.[campaign.id]}
        isClickTrackingVerified={isClickTrackingVerified}
      />
    );
    campaignElements.push(
      <CampaignsCard
        key={campaign.id}
        campaign={campaign}
        status={status}
        stats={stats}
        period={period}
        facebookProgress={facebookStatuses?.[campaign.id]}
        googleProgress={googleStatuses?.[campaign.id]}
      />
    );
  }

  return campaignElements;
};

export default CampaignsCards;
